/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type {
  ListTradingChallengeRegistrationRequestsOptions,
  ListTradingChallengeRegistrationRequestsStatus200,
  ListTradingChallengeRegistrationRequestsStatus400,
  ListTradingChallengeRegistrationRequestsStatus401,
  ListTradingChallengeRegistrationRequestsStatus403,
  ListTradingChallengeRegistrationRequestsStatus500,
} from '../types/ListTradingChallengeRegistrationRequests'
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { listTradingChallengeRegistrationRequests } from '../clients/listTradingChallengeRegistrationRequests'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const listTradingChallengeRegistrationRequestsQueryKey = ({
  query,
}: Omit<ListTradingChallengeRegistrationRequestsOptions, 'headers'> = {}) =>
  [{ url: '/v1/trading_challenges/registration_requests' }, ...(query ? [query] : [])] as const

type ListTradingChallengeRegistrationRequestsQueryKey = ReturnType<
  typeof listTradingChallengeRegistrationRequestsQueryKey
>

export function listTradingChallengeRegistrationRequestsQueryOptions(
  { query }: ListTradingChallengeRegistrationRequestsOptions = {},
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const queryKey = listTradingChallengeRegistrationRequestsQueryKey({ query })
  return queryOptions<
    ListTradingChallengeRegistrationRequestsStatus200,
    ResponseErrorConfig<
      | ListTradingChallengeRegistrationRequestsStatus400
      | ListTradingChallengeRegistrationRequestsStatus401
      | ListTradingChallengeRegistrationRequestsStatus403
      | ListTradingChallengeRegistrationRequestsStatus500
    >,
    ListTradingChallengeRegistrationRequestsStatus200,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return listTradingChallengeRegistrationRequests({
        ...config,
        query,
        signal: config.signal ?? signal,
        throwOnError: true,
      }).unwrap()
    },
  })
}

/**
 * @description The review queue. Admins see every tenant and may filter to one, an integrator is pinned to their own tenant, and a competition manager only sees the requests of the challenges assigned to them.
 * @summary List trading challenge registration requests
 * {@link /v1/trading_challenges/registration_requests}
 */
export function useListTradingChallengeRegistrationRequests<
  TData = ListTradingChallengeRegistrationRequestsStatus200,
  TQueryData = ListTradingChallengeRegistrationRequestsStatus200,
  TQueryKey extends QueryKey = ListTradingChallengeRegistrationRequestsQueryKey,
>(
  {
    query,
  }: {
    query?:
      | ListTradingChallengeRegistrationRequestsOptions['query']
      | (() => ListTradingChallengeRegistrationRequestsOptions['query'])
  } = {},
  options: {
    query?: Partial<
      QueryObserverOptions<
        ListTradingChallengeRegistrationRequestsStatus200,
        ResponseErrorConfig<
          | ListTradingChallengeRegistrationRequestsStatus400
          | ListTradingChallengeRegistrationRequestsStatus401
          | ListTradingChallengeRegistrationRequestsStatus403
          | ListTradingChallengeRegistrationRequestsStatus500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const resolvedParams = { query: typeof query === 'function' ? query() : query }
  const queryKey =
    resolvedOptions?.queryKey ?? listTradingChallengeRegistrationRequestsQueryKey(resolvedParams)

  const queryResult = useQuery(
    {
      ...listTradingChallengeRegistrationRequestsQueryOptions(resolvedParams, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | ListTradingChallengeRegistrationRequestsStatus400
      | ListTradingChallengeRegistrationRequestsStatus401
      | ListTradingChallengeRegistrationRequestsStatus403
      | ListTradingChallengeRegistrationRequestsStatus500
    >
  > & { queryKey: TQueryKey }

  queryResult.queryKey = queryKey as TQueryKey

  return queryResult
}
